import React from 'react';
import { StickyBar } from './components/StickyBar';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemaSection } from './components/ProblemaSection';
import { ParadigmaSection } from './components/ParadigmaSection';
import { SolucionSection } from './components/SolucionSection';
import { IncluyeSection } from './components/IncluyeSection';
import { ComoFuncionaSection } from './components/ComoFuncionaSection';
import { ResultadoSection } from './components/ResultadoSection';
import { PrecioSection } from './components/PrecioSection';
import { GarantiaSection } from './components/GarantiaSection';
import { TestimoniosSection } from './components/TestimoniosSection';
import { CTAFinalSection } from './components/CTAFinalSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { FixedCTABar } from './components/FixedCTABar';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-brand-black selection:bg-brand-orange selection:text-brand-black pb-16 md:pb-0" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyBar data-id="element-2" />
      <Navbar data-id="element-3" />

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <ProblemaSection data-id="element-6" />
        <ParadigmaSection data-id="element-7" />
        <SolucionSection data-id="element-8" />
        <IncluyeSection data-id="element-9" />
        <ComoFuncionaSection data-id="element-10" />
        <ResultadoSection data-id="element-11" />
        <PrecioSection data-id="element-12" />
        <GarantiaSection data-id="element-13" />
        <TestimoniosSection data-id="element-14" />
        <CTAFinalSection data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
      <WhatsAppButton data-id="element-17" />
      <FixedCTABar data-id="element-18" />
    </div>;
}